import axios from "axios";

const loadAbort = () => new AbortController();

export const v2PolygonsEndpoint = (params: { level?: number; parent?: number; price_type?: string; min_price?: number; max_price?: number }) => {
  const controller = loadAbort();
  const query = new URLSearchParams();
  if (params.level !== undefined) query.set("level", String(params.level));
  if (params.parent !== undefined) query.set("parent_id", String(params.parent));
  if (params.price_type) query.set("price_type", params.price_type);
  // No enviar filtros si ambos son 0 o menos; no enviar max si es <= min
  const { min_price, max_price } = params;
  const hasMin = (min_price ?? 0) > 0;
  const hasMax = (max_price ?? 0) > 0;
  if (hasMin || hasMax) {
    if (hasMin) query.set("min_price", String(min_price));
    if (hasMax && max_price! > (min_price ?? 0)) query.set("max_price", String(max_price));
  }
  return {
    call: (urlService: string) =>
      axios.get(`${urlService}/address/v2/polygons?${query}`, {
        headers: { "Content-Type": "application/json" },
      }),
    controller,
  };
};

export const priceStatsEndpoint = (polygonId: number) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios.get(`${urlService}/address/v2/polygons/${polygonId}/price-stats`, {
        headers: { "Content-Type": "application/json" },
      }),
    controller,
  };
};

export const polygonsByLevelEndpoint = (level: number) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios.get(`${urlService}/address/v1/polygons?level=${level}`, {
        headers: { "Content-Type": "application/json" },
      }),
    controller,
  };
};

export const polygonsByParentEndpoint = (parent: number) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios.get(`${urlService}/address/v1/polygons?parent=${parent}`, {
        headers: { "Content-Type": "application/json" },
      }),
    controller,
  };
};
